import { render } from "./HomeDepositMethods.vue?vue&type=template&id=a9a1eb54&scoped=true"
import script from "./HomeDepositMethods.vue?vue&type=script&lang=js"
export * from "./HomeDepositMethods.vue?vue&type=script&lang=js"

import "./HomeDepositMethods.vue?vue&type=style&index=0&id=a9a1eb54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a1eb54"]])

export default __exports__